import { Autocomplete, Box, Button, Card, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import Headline from '../../../components/headline/Headline'
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import { useNavigate } from 'react-router-dom';
import { post, Token } from '../../../Script/Session';

function RegionalgruppeZuweisen() {
    const [wit, setWit] = useState("87.5%");
    const [reggroups, setreggroups] = useState();
    const navigate = useNavigate();
    const [users, setusers] = useState();
    const [selecteduser,setselecteduser] = useState();
    const [selectedgroup,setselectedgroup] = useState();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setreggroups(JSON.parse(response));
    }, []);

    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        setusers(JSON.parse(response));
    }, []);

    function setit(){
        let body = {};
        body.token = Token.get();
        body.action = "set";
        console.log(selecteduser.id);
        console.log(reggroups.id);
        body.userid = selecteduser.id;
        body.reggruppeid = selectedgroup.id;
        let response = post(body, "/regionalgruppen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        alert("Gespeichert!");
        window.location.reload();
    }

    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
                <Headline title={"Regionalgruppen"} />
                <Card sx={{mt: 2, width: "80%"}}>
                    <Typography level="title-md">Regionalgruppe zuweisen</Typography>
                    <Autocomplete onChange={(e,newv) => setselecteduser(newv)} options={users?.result || []} getOptionLabel={(item) => item.name} placeholder='Nutzer'></Autocomplete>
                    <Autocomplete onChange={(e,newv) => {
                        setselectedgroup(newv)
                        console.log(newv);
                    }
                        
                        } options={reggroups?.result || []} getOptionLabel={(item) => item.name}  placeholder='Regionalgruppe'/>
                    <Button onClick={() => setit()} sx={{width: "10%"}}>
                        Setzen
                    </Button>
                </Card>
            </Box>
                



            <NavigationBar state={"adminhome"} back={true} />
        </>
    )
}

export default RegionalgruppeZuweisen
